import React, { useEffect, useState } from "react";
import { listarRevendasDropdown, relatorioFaturamentoComposicao } from "../services/api";
import RelatorioComposicaoView from "./RelatorioComposicaoView";

const RelatorioRevenda = ({ token }) => {
  const now = new Date();
  const [revendas, setRevendas] = useState([]);
  const [revendaId, setRevendaId] = useState("");
  const [ano, setAno] = useState(String(now.getFullYear()));
  const [mes, setMes] = useState(String(now.getMonth() + 1));
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    listarRevendasDropdown(token)
      .then((r) => setRevendas(Array.isArray(r.data) ? r.data : r.data?.items || []))
      .catch(() => setRevendas([]));
  }, [token]);

  const carregar = async () => {
    if (!revendaId) {
      alert("Selecione a revenda.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await relatorioFaturamentoComposicao(token, {
        revendaId,
        ano: Number(ano),
        mes: Number(mes),
        aplicarCarencia: true,
      });
      setDados(data);
    } catch (e) {
      console.error(e);
      setDados(null);
      alert("Erro ao carregar o relatório.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto zen-card rounded-2xl p-6">
      <div className="mb-4">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">Faturamento da revenda</h2>
        <p className="text-sm text-gray-500 dark:text-slate-300">Mesmo formato do faturamento do distribuidor, com a tabela de preço da revenda.</p>
      </div>
      <div className="flex flex-wrap gap-3 items-end mb-6">
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Revenda</label>
          <select
            value={revendaId}
            onChange={(e) => setRevendaId(e.target.value)}
            className="px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white"
          >
            <option value="">Selecione</option>
            {revendas.map((r) => (
              <option key={r.id} value={r.id}>
                {r.nomeFantasia || r.razaoSocial}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Mês</label>
          <input value={mes} onChange={(e) => setMes(e.target.value)} className="w-20 px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white" />
        </div>
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Ano</label>
          <input value={ano} onChange={(e) => setAno(e.target.value)} className="w-24 px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white" />
        </div>
        <button
          type="button"
          onClick={carregar}
          disabled={loading}
          className="px-4 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold disabled:opacity-60"
        >
          {loading ? "Carregando..." : "Gerar"}
        </button>
      </div>
      <RelatorioComposicaoView dados={dados} />
    </div>
  );
};

export default RelatorioRevenda;
